<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} MENU</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="CENTRAL HIDROELECTRICA IHABAR MOLINO" width="100%" height="100%" :size="4" color="cyan"
            border="solid 6px yellow"></HmiLabel>
        </div>
        <div class="grid">
          <div class="custom-row">
            <HmiLabel class="grid-item" label="NIVEL COMPUERTA" width="25%" height="80%" :size="1.7" color="cyan">
            </HmiLabel>
            <HmiLabel class="grid-item" :label="formatoCM(nivelCompuerta) + ' cm.'" width="25%" height="80%" :size="1.7"
              color="#C0C000">
            </HmiLabel>
            <HmiLabel class="grid-item" label="NIVEL CAMARA CARGA" width="25%" height="80%" :size="1.7" color="cyan">
            </HmiLabel>
            <HmiLabel class="grid-item" :label="formatoCM(nivelCamaraCarga) + ' cm.'" width="25%" height="80%" :size="1.7"
              color="#00C0FF">
            </HmiLabel>
          </div>
          <div class="custom-row">
            <HmiButton class="grid-item" label="COMPUERTA CANAL" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToCompuerta"></HmiButton>
            <HmiButton class="grid-item" label="GENERADOR" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToGenerador"></HmiButton>
            <HmiButton class="grid-item" label="REGULACION" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToRegulacion"></HmiButton>
            <HmiButton class="grid-item" label="AJUSTES NIVEL" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToAjustesNivel"></HmiButton>
          </div>
          <div class="custom-row">
            <HmiButton class="grid-item" label="TEMPERATURAS" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToTemperaturas"></HmiButton>
            <HmiButton class="grid-item" label="MANUAL" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToManual"></HmiButton>
            <HmiButton class="grid-item" label="LIMPIARREJAS" width="25%" height="80%" :size="1.7" color="silver"
              @click.native="navigateToLimpiarrejas"></HmiButton>
            <HmiButton class="grid-item" label="ALARMAS" width="25%" height="80%" :size="1.7" color="#FF00C0"
              @click.native="navigateToAlarmas"></HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "@/components/HMI/HmiPantalla.vue";

export default {
  name: "MenuPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajando
    // Lo calculamos en cada "pestaña" para captar cambios en la URL
    // De /pantalla/1/compuerta podemos pasar a /pantalla/2/compuerta
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },
    direccionVariables() {
      // Son las mismas para gen1 y gen2
      return {
        NIVEL_COMPUERTA_LECTURA: 37, // Correspondiente a Dm84
        NIVEL_CAMARA_CARGA_LECTURA: 49, // Correspondiente a Dm122
      };
    },
    nivelCompuerta() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_COMPUERTA_LECTURA
        ];
      }
      return "0000";
    },
    nivelCamaraCarga() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_CAMARA_CARGA_LECTURA
        ];
      }
      return "0000";
    },
  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Compuerta"
    navigateToCompuerta() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/compuerta`);
    },

    // Navegación a "Generador"
    navigateToGenerador() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/generador`);
    },

    // Navegación a "Regulacion"
    navigateToRegulacion() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/regulacion`);
    },

    // Navegación a "Ajustes Nivel"
    navigateToAjustesNivel() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/ajustesnivel`);
    },

    // Navegación a "Temperaturas"
    navigateToTemperaturas() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/temperaturas`);
    },

    // Navegación a "Manual"
    navigateToManual() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/manual`);
    },

    // Navegación a "Limpiarrejas"
    navigateToLimpiarrejas() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/limpiarrejas`);
    },

    // Navegación a "Alarmas"
    navigateToAlarmas() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/alarmas`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "0", "");
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "0", "");
    },

    //Formatear cm
    formatoCM(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  padding-top: clamp(1px, 2vw - 5px, 20px);
  height: 85%;
  display: flex;
  flex-direction: column;
  gap: clamp(1px, 10vw - 2000px, 20px);
}

.custom-row {
  height: 33%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* gap: 20px; */
}

.custom-row>* {
  margin-right: clamp(1px, 1vw, 20px);
  /* o el espacio que desees */
}

.custom-row>*:last-child {
  margin-right: 0;
  /* para asegurarse de que el último elemento no tenga un margen derecho */
}
</style>
